import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosUserService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/posUsers";

  searchUser(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

	getUser(Page: number, size: number, sort: any): Observable<Object> {
		return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
	}
	
	getAllUserDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/dropdown`);
	  }

	  getUserById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	  }
	

	  createUser(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, Purchase);
	}

	deleteByUserId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
	downloadUsersTemplate(): Observable<any> {
		return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
	  }
	  downloadUserReport(Page: number, size: number, sort,selectionUser): Observable<any> {
		return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionUser, { 
		  responseType: 'arraybuffer',
		  observe: 'response'
		});
	  }

	usersDownload(Page: any, size: any, sort: any): Observable<Object> {
		return this.getUser(Page, size, sort);
	}

	usersDownloadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.searchUser(query, Page, size, sort);
	}

}
